import classNames from 'classnames';
import * as React from 'react';

export type TabsProps = {
  'data-testid'?: never;
  children?: React.ReactNode;
  className?: string;
  error?: boolean;
  size: 'lg' | 'md' | 'sm' | 'xs';
  testId?: string;
  variant: 'square' | 'round' | 'ghost';
};

export const Tabs: React.VFC<TabsProps> = ({
  children,
  className,
  error,
  size,
  testId,
  variant,
}) => (
  <div
    className={classNames(
      className,
      'vb-tabs',
      `vb-tabs-size--${size}`,
      `vb-tabs-variant--${variant}`,
      {
        'vb-tabs-state--error': error,
      }
    )}
    data-testid={testId}
  >
    {children}
  </div>
);
